/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";

import { useTranslation } from "react-i18next";
import "./NotFound.css";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";

const NotFoundContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ flex: "1 1 0%", position: "relative" }}>
        <div id="content">
          <section className="notfound-body">
            <div className="notfound-content">
              <div className="notfound-404">404</div>
              <div className="notfound-pagenotfound">
                <div className="notfound-title">   {t("notfound.title")}</div>
                <div className="notfound-note">
               {t("notfound.note")}
                </div>
                <a className="btn-yellow-small mt-16" href="/">
                {t("notfound.button_return")}
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
      <NavbarBottom />
    </>
  );
};

export default NotFoundContent;
